<template>
  <div class="order-meta-wrap">
    <div id="detailBar" class="order-meta-bar detailBar">
      <div class="order-meta-bar__selectors">
        <button
          type="button"
          class="order-meta-bar__chip"
          @click="visibleHandler(1)"
        >
          <i class="fas fa-users" aria-hidden="true"></i>
          <span class="order-meta-bar__label">Customer</span>
          <span class="order-meta-bar__value">{{ customerLabel }}</span>
          <i
            class="fas fa-caret-down order-meta-bar__caret"
            aria-hidden="true"
          ></i>
        </button>

        <button
          type="button"
          class="order-meta-bar__chip"
          @click="visibleHandler(2)"
        >
          <i class="fas fa-male" aria-hidden="true"></i>
          <span class="order-meta-bar__label">Waiter</span>
          <span class="order-meta-bar__value">{{ waiterLabel }}</span>
          <i
            class="fas fa-caret-down order-meta-bar__caret"
            aria-hidden="true"
          ></i>
        </button>

        <button
          type="button"
          class="order-meta-bar__chip"
          @click="visibleHandler(3)"
        >
          <i class="fas fa-crosshairs" aria-hidden="true"></i>
          <span class="order-meta-bar__label">Place</span>
          <span class="order-meta-bar__value">{{ placeLabel }}</span>
          <i
            class="fas fa-caret-down order-meta-bar__caret"
            aria-hidden="true"
          ></i>
        </button>
      </div>

      <div v-if="$slots['order-tools']" class="order-meta-bar__tools">
        <slot name="order-tools"></slot>
      </div>

      <div class="order-meta-bar__clock">{{ DateTime }}</div>
    </div>

    <Sidebar
      Id="orderMetaSidebar"
      Id1="detailBar"
      :autoClose="true"
      :value="visible"
      @input="onSidebarInput"
    >
      <template v-slot:default>
        <div
          class="row order-sidebar-menu text-center bg_gray h-100"
          v-if="selected == 0"
        >
          <div
            class="col-lg-4 col-md-4"
            v-for="(item, index) in items"
            :key="index"
            @click="selected = item.id"
          >
            <a class="box_topic" href="#0">
              <span><i :class="item.icon"></i></span>
              <h3>{{ item.title }}</h3>
              <p>
                {{ item.subtitle }}
              </p>
            </a>
          </div>
        </div>
        <div class="row bg_gray order-sidebar-panel" v-if="selected != 0">
          <div class="col-12">
            <div v-if="selected == 1">
              <SearchCustomer
                :selectedCustomer="selectedCustomer"
                @SelectCustomer="SelectCustomer($event)"
              />
            </div>
            <div v-if="selected == 2">
              <Waiterlist
                :selectedWaiter="selectedWaiter"
                @SelectWaiter="SelectWaiter($event)"
              />
            </div>
            <div v-if="selected == 3">
              <PlaceList
                :selectedPlace="selectedPlace"
                @SelectPlace="SelectPlace($event)"
              />
            </div>
          </div>
        </div>
      </template>
    </Sidebar>
  </div>
</template>

<script>
import moment from 'moment';
import { Sidebar } from '@/components/base/index.js';
import PlaceList from '../PlaceList/index';
import Waiterlist from '../WaiterList/index';

import Card from './Card';
import SearchCustomer from '../SearchCustomer/index';
import './style.css';

export default {
  name: 'TopSelectionBar',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    selectedCustomer: {
      type: Object,
      default: () => ({}),
    },
    selectedPlace: {
      type: Object,
      default: () => ({}),
    },
    selectedWaiter: {
      type: Object,
      default: () => ({}),
    },
  },
  watch: {
    visible: function(value) {
      if (!value) {
        this.selected = 0;
      }
    },
  },

  created() {
    setInterval(() => {
      this.GetDateTime();
    }, 1000);
  },

  data: () => ({
    selected: 0,
    DateTime: null,
    items: [
      {
        id: 1,
        icon: 'icon_wallet',
        title: 'Customer',
        subtitle: 'Registered as a customer',
      },
      {
        id: 2,
        icon: 'icon_cloud-upload_alt',
        title: 'Waiter',
        subtitle: 'Waiter attending the order',
      },
      {
        id: 3,
        icon: 'icon_lifesaver',
        title: 'Place',
        subtitle: 'Table or Room location ',
      },
    ],
  }),
  computed: {
    customerLabel() {
      return this.truncateLabel(
        this.selectedCustomer && this.selectedCustomer.name,
        14,
      );
    },
    waiterLabel() {
      return this.truncateLabel(
        this.selectedWaiter && this.selectedWaiter.name,
        12,
      );
    },
    placeLabel() {
      return this.truncateLabel(
        this.selectedPlace && this.selectedPlace.name,
        10,
      );
    },
  },
  methods: {
    truncateLabel(name, max) {
      if (!name) return '-';
      const text = String(name);
      return text.length > max ? `${text.substring(0, max)}…` : text;
    },
    visibleHandler(value) {
      this.selected = value;
      this.$emit('visibleHandler', !this.visible);
    },
    GetDateTime() {
      this.DateTime = moment().format('MMM D, h:mm:ss a');
    },
    closeSidebar() {
      this.selected = 0;
      this.$emit('outerClick', false);
      this.$emit('visibleHandler', false);
    },
    onSidebarInput(open) {
      if (!open) {
        this.closeSidebar();
      }
    },
    SelectPlace(place) {
      this.$emit('SelectPlace', place);
      this.closeSidebar();
    },
    SelectWaiter(waiter) {
      this.$emit('SelectWaiter', waiter);
      this.closeSidebar();
    },
    SelectCustomer(customer) {
      this.$emit('SelectCustomer', customer);
      this.closeSidebar();
    },
  },
  components: {
    PlaceList,
    Waiterlist,
    Sidebar,
    Card,
    SearchCustomer,
  },
};
</script>

<style scoped>
.order-meta-wrap {
  position: relative;
  height: 46px;
  z-index: 12;
  background: #f1f5f9;
}

.order-sidebar-menu {
  height: 100%;
  padding: 48px 24px;
}

.order-sidebar-panel {
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 8px 0 24px;
  min-height: 100%;
  background: #f8fafc;
  overflow: visible;
}

.order-sidebar-panel .col-12 {
  width: 100%;
  padding: 0;
}
</style>
